module.exports = __webpack_public_path__ + "static/media/subscribe.8afe51b1.png";